/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Delete_Button_TitleInputs */



/**
* | output |
* | --- |
* | "Remove Event" |
*
* @param {Event_Delete_Button_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_delete_button_title = /** @type {((inputs?: Event_Delete_Button_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Delete_Button_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover evento")
	return /** @type {LocalizedString} */ ("Remove Event")
});